import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import Unit from '@/models/_deprecated/Unit';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type ProjectUnitProps = {
  units?: Unit[];
};

export default function ProjectUnit({ units }: ProjectUnitProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.card',
  });
  const unitsText = units?.map(unit => unit.name).join(', ');

  return (
    <ConditionalRenderer condition={units?.length}>
      <div className="p-1 bg-hackathon-secondary/10 border-hackathon-secondary border rounded-[4px] flex flex-col gap-1">
        <div className="flex gap-1.5 items-center flex-wrap">
          <MapPinIcon className="w-4 h-4" />
          <Text text={t('unit')} className="shrink-0" />
          <Text text={unitsText} />
        </div>
      </div>
    </ConditionalRenderer>
  );
}
